'use strict';
function getBannerHeigth() {
    $(document).find('.js-header-banner').removeClass('d-none');
    var h = $(document).find('.js-header-banner .cc-item').height();
    // $(document).find('.js-header-banner').addClass('d-none');
    return h;
};

function initializeBannerHeader () {
    var height, heightBanner, tot, timeToShift;
    if ($(document).find('.js-banner-slider').length > 0) {
        timeToShift = $(document).find('.js-banner-slider').data('timetoshift') != undefined ? $(document).find('.js-banner-slider-fade').data('timetoshift') : 10000;
        heightBanner = getBannerHeigth();
        $('.js-banner-slider').each(function () {
            var slidesContainer = $(this);

            slidesContainer.slick({
                infinite: true,
                autoplay: true,
                focusOnSelect: false,
                centerMode: true,
                autoplaySpeed: timeToShift,
                speed: 500,
                slidesToScroll: 1,
                slidesToShow: 1,
                variableWidth: false,
                dots: false,
                arrow: true,
                fade: false,
                prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
            });

            $('.cc-slider-prev').attr('aria-label', window.commonAria.prevSlide.label);
            $('.cc-slider-next').attr('aria-label', window.commonAria.nextSlide.label);
        });
        // $('.js-banner-slider').slick('refresh');
        height = 0;
        if ($('body').hasClass('cc-mobile') || $('body').hasClass('cc-tablet-portrait')) {
            height = 81;
        } else {
            height = 139;
        }
        tot = parseInt(height + heightBanner);
        $('.js-header, :not(.cc-page-header-fixed)>.cc-content-header').css({ 'min-height': tot });
    } else if ($(document).find('.js-banner-slider-fade').length > 0) {
        timeToShift = $(document).find('.js-banner-slider-fade').data('timetoshift') != undefined ? $(document).find('.js-banner-slider-fade').data('timetoshift') : 10000;
        heightBanner = getBannerHeigth();
        $('.js-banner-slider-fade').each(function () {
            var slidesContainer = $(this);
            if (!$(this).hasClass('slick-initialized')) {
                slidesContainer.slick({
                    infinite: true,
                    autoplay: true,
                    focusOnSelect: false,
                    centerMode: true,
                    autoplaySpeed: timeToShift,
                    speed: 1000,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    fade: true,
                    // cssEase: 'cubic-bezier(0,.42,1,.7) 1s',
                    // cssEase: 'ease-in-out',
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
                });
            }
            $('.cc-slider-prev').attr('aria-label', window.commonAria.prevSlide.label);
            $('.cc-slider-next').attr('aria-label', window.commonAria.nextSlide.label);

        });
        // $('.js-banner-slider-fade').slick('refresh');
        $('.js-banner-slider-fade').on('beforeChange', function() {
            $(document).find('.js-banner-slider-fade .cc-item').removeClass('animated fadeInLeft').css({'opacity': '0', 'transition': 'opacity 0.5s'});
        });
        $('.js-banner-slider-fade').on('afterChange', function() {
            setTimeout(() => {
                $(document).find('.js-banner-slider-fade .cc-item').addClass('animated fadeInLeft').css({'opacity': '1', 'transition': 'opacity 0.5s'});
            }, 50);
        });

        // fix share and heart buttons showing behind header banner
        if ($('body').hasClass('cc-mobile') || $('body').hasClass('cc-tablet')) {
            var unobserveTimeout;
            const resizeObserver = new ResizeObserver(element => {
                var h = $('.js-header').height();
                $('.js-header, :not(.cc-page-header-fixed)>.cc-content-header').css({ 'min-height': h });

                // stop the observer after 30 secs from the last size change.
                if (unobserveTimeout){
                    window.clearTimeout(unobserveTimeout);
                }
                unobserveTimeout = setTimeout(() => {
                    resizeObserver.unobserve($('.js-header-banner')[0]);
                }, 30 * 1000);
            });
            resizeObserver.observe($('.js-header-banner')[0]);
        }
    }
}
module.exports = {
    initializeBannerHeader: initializeBannerHeader
};
